import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import * as parseSpotifyUri from 'spotify-uri';
import {BiolinkEditorService} from '../../biolink-editor.service';

export interface CrupdateWidgetDialogData {
    biolinkId: number;
    widgetId?: number;
    config?: {url?: string};
}

@Component({
    selector: 'spotify-widget-modal',
    templateUrl: './spotify-widget-modal.component.html',
    styleUrls: ['./spotify-widget-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpotifyWidgetModalComponent {
    static type = 'spotifyEmbed';
    errors$ = new BehaviorSubject<{url?: string}>({});
    form = new FormGroup({
        url: new FormControl(''),
    });

    constructor(
        private dialogRef: MatDialogRef<SpotifyWidgetModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CrupdateWidgetDialogData,
        public editor: BiolinkEditorService,
    ) {
        if (data.config?.url) {
            this.form.patchValue({url: data.config?.url});
        }
    }

    createOrUpdate() {
        const spotifyInfo = parseSpotifyUri(this.form.value.url);
        if (!('id' in spotifyInfo)) {
            return this.errors$.next({url: 'This is not a valid spotify url.'});
        }

        this.editor
            .crupdateWidget(this.data.widgetId, SpotifyWidgetModalComponent.type, this.form.value)
            .subscribe(response => {
                this.dialogRef.close(response.widget);
            });
    }

    close() {
        this.dialogRef.close();
    }
}
